import { render, staticRenderFns } from "./MediaCooperation.vue?vue&type=template&id=6baa1270&scoped=true"
import script from "./MediaCooperation.vue?vue&type=script&lang=js"
export * from "./MediaCooperation.vue?vue&type=script&lang=js"
import style0 from "./MediaCooperation.vue?vue&type=style&index=0&id=6baa1270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa1270",
  null
  
)

export default component.exports